import Map from "@identitybuilding/idb-react-100-percent-local"
import MapStadGemeente from "@identitybuilding/idb-react-100-percent-local/dist/MapStadGemeente"


import { useHistory } from "react-router-dom";
import React from "react";
import Navigation from "./Navigation";
import { useSelector, useDispatch } from "react-redux";
import { toggleLoginScreen, toggleInfoSlider } from "../actions/AccountAction";
import axios from "axios";
import { useEffect, useState } from "react";
import { getEnvEndpoints } from "../utils/functions";
const routeMap = {
  nl: { collaboration: "/actieve-gemeenten", following: "/wie-volg-ik" },
  fr: { collaboration: "/communes-actives", following: "/mes-suivis" },
  en: { collaboration: "/active-municipalities", following: "/who-i-follow" },
  de: { collaboration: "/aktive-gemeinden", following: "/wer-folge-ich" },
};

const Main = (props) => {
  const history = useHistory();
  const dispatch = useDispatch(); // Initialize dispatch
  const lang = useSelector((state) => state.general.lang);
  const routePath_HasCollaboration = routeMap[lang]?.collaboration || routeMap.nl.collaboration;
  const routePath_Following = routeMap[lang]?.following || routeMap.nl.following;
  const loginScreen = useSelector((state) => state.account.loginScreen); // Access loginScreen state
  const accountData = useSelector((state) => state.account.accountData); // Determine if logged in
  const [followingMunicipalities, setFollowingMunicipalities] = useState([]); // State for followed municipalities
  const { followState, infoSliderOpen } = useSelector((state) => state.account);
  const [matchingMunicipalities, setMatchingMunicipalities] = useState([]);
  const [municipalityNames, setMunicipalityNames] = useState([]);
  const env = getEnvEndpoints();

  const [platformStats, setPlatformStats] = useState(null);
  const [recentRegistrations, setRecentRegistrations] = useState([]);
  const [recentPublications, setRecentPublications] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    axios.get(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/platform-stats/`)
      .then(res => setPlatformStats(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    axios.get(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/recent-registrations/?lang=${lang}`)
      .then(res => setRecentRegistrations(res.data.recent_registrations || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    axios.get(`${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/recent-publications/?lang=${lang}`)
      .then(res => setRecentPublications(res.data.recent_publications || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const navigationElement = document.querySelector("nav"); // Adjust the selector if necessary
    if (loginScreen) {
      navigationElement?.classList.add("blurred");
    } else {
      navigationElement?.classList.remove("blurred");
    }
  }, [loginScreen]);

  const login = (e) => {
    e.preventDefault();
    dispatch(toggleLoginScreen(true)); // Example Redux action
  };

  const openInfoSlider = (e) => {
    if (e) e.preventDefault();
    dispatch(toggleInfoSlider(true));
  };

  // Auto-open info slider for 10 seconds, only once per session
  useEffect(() => {
    if (sessionStorage.getItem("infoSliderShown")) return;
    sessionStorage.setItem("infoSliderShown", "true");
    dispatch(toggleInfoSlider(true));
    const timer = setTimeout(() => {
      dispatch(toggleInfoSlider(false));
    }, 10000);
    return () => {
      clearTimeout(timer);
      dispatch(toggleInfoSlider(false));
    };
  }, []);

  useEffect(() => {
    // Fetch the user's followed municipalities from the backend
    const fetchFollowingMunicipalities = async () => {
      if (localStorage.getItem("StadGemeenteToken")) {
        try {
          const headers = {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("StadGemeenteToken")}`,
          };
          const response = await axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/stadgemeente/user/`,
            { headers }
          );
          if (response.data?.following_municipalities_nis_codes) {
            const nisCodes = response.data.following_municipalities_nis_codes;
            setFollowingMunicipalities(
              nisCodes // Use the correct key
            );
          }
          if (response.data?.following_municipalities_nis_codes) {
            const userNisCodes = response.data?.following_municipalities_nis_codes;
            // Fetch all municipalities
            const municipalitiesResponse = await axios.get(
              `${env.REACT_APP_BASE_MEDIA_URL}/core/new-api/geo/municipality/?fields=id,name_nl,name_fr,name_de,name_en,nis_code&paginate=false&ordering=name_nl,name_fr,name_de,name_en,nis_code`,
              { headers }
            );
  
            if (municipalitiesResponse.data) {
              // Filter matching municipalities
              const matching = municipalitiesResponse.data.filter(municipality =>
                  userNisCodes.includes(municipality.nis_code)
              );
          
              // Transform data based on language preference
              const names = matching.map(municipality => {
                  return {
                      name: municipality[`name_${lang}`] || 
                            municipality.name_en || 
                            municipality.name_fr || 
                            municipality.name_de || 
                            municipality.name_nl || 
                            "Unknown"
                  };

              });
              setMunicipalityNames(names); 


          }
          
          }
        } catch (error) {
          console.error("Error fetching following municipalities:", error);
        }
      }

      setLoading(false); // Set loading to false after data is fetched
    };

    fetchFollowingMunicipalities();
  }, []); // Run only once on component mount

  const goToPage = (e) => {

    let municipalityName = e["Name" + lang.toUpperCase()] ? e["Name" + lang.toUpperCase()].toLowerCase()
      .replace(" (stad)", '')
      .replace(" (ville)", '')
      .replace(" (stadt)", '')
      .replace(" city", '')
      .replace(/\ /g, '')
      .replace("'", '')
      .replace("lalouviere", "la louvière")
      .replace("lacalamine", "la calamine")
      .replace("labruyere", "la-bruyere")
      .replace("lahulpe", "la hulpe")
      .replace("fontaine-lévêque", 'fontaine-levêque')
      :
      e.name
        .replace(" (stad)", '')
        .replace(" (ville)", '')
        .replace(" (stadt)", '')
        .replace(" city", '')
        .replace(/\ /g, '')
        .replace("'", '')
        .replace("lalouviere", "la louvière")
        .replace("lacalamine", "la calamine")
        .replace("labruyere", "la-bruyere")
        .replace("lahulpe", "la hulpe")
        .replace("fontaine-lévêque", 'fontaine-levêque')
    if (municipalityName === 'sgravenbrakel') { municipalityName = 's-gravenbrakel' }
    if (municipalityName === 'mont-de-lenclus') { municipalityName = 'montdelenclus' }
    if (municipalityName === 'lesbonsvillers') { municipalityName = 'les-bons-villers' }
    if (window.location.hostname === 'localhost') {
      history.push(`/${municipalityName.toLowerCase()}`);
    }
    else {
      window.open(`https://${window.location.hostname}/${municipalityName.toLowerCase()}`)
    }


  }

  return (
    <div>
      {loading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          
        </div>
      ) : (
        <>
          <Navigation lang={lang} recentRegistrations={recentRegistrations} recentPublications={recentPublications} />
          {accountData && window.location.href.includes(routePath_HasCollaboration) ? (
            <Map
              lang={lang}
              MyCity={true}
              getData={(e) => goToPage(e)}
              loggedIn={Boolean(accountData)}
              followingMunicipalities={followingMunicipalities}
              followState={followState}
              login={login}
              openInfoSlider={openInfoSlider}
              infoSliderOpen={infoSliderOpen}
              platformStats={platformStats}
            />
          ) : accountData ? (
            <MapStadGemeente
              lang={lang}
              MyCity={true}
              getData={(e) => goToPage(e)}
              loggedIn={Boolean(accountData)}
              followingMunicipalities={followingMunicipalities}
              followState={followState}
              login={login}
              openInfoSlider={openInfoSlider}
              infoSliderOpen={infoSliderOpen}
              platformStats={platformStats}
              followingMunicipalitiesNames = {municipalityNames}
            />
          ) : (
            <Map
              lang={lang}
              MyCity={true}
              getData={(e) => goToPage(e)}
              loggedIn={Boolean(accountData)}
              followingMunicipalities={followingMunicipalities}
              followState={followState}
              login={login}
              openInfoSlider={openInfoSlider}
              infoSliderOpen={infoSliderOpen}
              platformStats={platformStats}
            />
          )}

        </>
      )}
    </div>
  );
};

export default Main;
